<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";

	const { COOKIES } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Layout>
	<div class="mx-auto px-4 md:px-6 lg:max-w-[min(70%,90rem)]">
		<h1 class="text-[2.25rem] lg:text-xl">{nbspify("Bezpečnost a ochrana osobních údajů")}</h1>
		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Totožnost a kontaktní údaje správce")}</h2>
		<table class="my-6 max-w-[35rem]">
			<tr class="text-xs">
				<td class="border-gray border p-3">{nbspify("Firma: ")}</td>
				<td class="border-gray border p-3">{nbspify("BITO skladovací technika CZ s.r.o.")}</td>
			</tr>
			<tr class="bg-gray-50 text-xs">
				<td class="border-gray border p-3">{nbspify("Sídlo: ")}</td>
				<td class="border-gray border p-3">{nbspify("Kolbenova 923/34a, 190 00 Praha 9, Pragovka")}</td>
			</tr>
			<tr class="text-xs">
				<td class="border-gray border p-3">{nbspify("IČ: ")}</td>
				<td class="border-gray border p-3">{nbspify("27298221")}</td>
			</tr>
			<tr class="bg-gray-50 text-xs">
				<td class="border-gray border p-3">{nbspify("Telefon: ")}</td>
				<td class="border-gray border p-3">{nbspify("+420 733 643 229")}</td>
			</tr>
			<tr class="text-xs">
				<td class="border-gray border p-3">{nbspify("E-mail: ")}</td>
				<td class="border-gray border p-3">{nbspify("veronika.snajdarova@bito.com")}</td>
			</tr>
		</table>
		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Jaké typy osobních údajů shromažďujeme?")}</h2>
		<p>
			{nbspify(
				"Shromažďujeme pouze osobní údaje, které nám poskytnete za účelem komunikace nebo zodpovězení vašeho dotazu. Tyto údaje mohou zahrnovat:",
			)}
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside list-disc">
			<li>{nbspify("Jméno a přijmení")}</li>
			<li>{nbspify("Název firmy")}</li>
			<li>{nbspify("Adresu")}</li>
			<li>{nbspify("Telefonní číslo")}</li>
			<li>{nbspify("Obsah vašeho dotazu")}</li>
		</ul>
		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Za jakým účelem zpracováváme osobní údaje?")}</h2>
		<p>
			{nbspify("Osobní údaje zpracováváme výhradně za účelem:")}
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside list-disc">
			<li>{nbspify("Komunikace s vámi na základě vašeho dotazu")}</li>
			<li>{nbspify("Poskytování požadovaných informací nebo služeb")}</li>
			<li>{nbspify("Zajištění odpovědí na vaše dotazy")}</li>
		</ul>
		<p>
			{nbspify("Vaše údaje nevyužíváme k žádným marketingovým účelům bez vašeho předchozího výslovného souhlasu.")}
		</p>
		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Sdílení osobních údajů s třetími stranami")}</h2>
		<p>
			{nbspify(
				"Vaše osobní údaje nesdílíme s žádnými třetími stranami, kromě situací, kdy je to nezbytné k vyřízení vašeho dotazu nebo vyplývá ze zákonné povinnosti.",
			)}
		</p>

		<div
			class="[&_table]:font-fustat overflow-x-auto py-8 [&_table]:min-w-[47.375rem] [&_tbody>tr]:bg-gray-50 [&_td]:text-xs"
		>
			{@html `<script type="text/javascript" charset="UTF-8" data-cookiescriptreport="report" src="//report.cookie-script.com/r/${COOKIES}.js"></script>`}
		</div>

		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Jak využíváme Cookies")}</h2>
		<p>
			{nbspify(
				"Na našem webu používáme pouze technické cookies nezbytné pro správné fungování webových stránek. Pokud bychom využívali analytické nebo marketingové cookies, budete mít možnost udělit souhlas prostřednictvím funkce opt-in.",
			)}
		</p>

		<h2 class="mt-12 text-lg lg:text-[2rem]">
			{nbspify("Bezpečnostní opatření při uchovávání osobních údajů")}
		</h2>
		<p>
			{nbspify("Pro ochranu vašich osobních údajů jsme zavedli následující opatření:")}
		</p>
		<ul class="mb-3 ml-5 mt-1 list-outside list-disc">
			<li>{nbspify("Přístup k údajům je omezen pouze na pověřené osoby")}</li>
			<li>{nbspify("Data jsou uchovávána na zabezpečených serverech")}</li>
			<li>{nbspify("Používáme šifrování pro přenos citlivých údajů")}</li>
		</ul>

		<h2 class="mt-12 text-lg lg:text-[2rem]">
			{nbspify("Jak můžete kontrolovat své osobní údaje?")}
		</h2>
		<p>
			{nbspify(
				"Pokud chcete ověřit, jaké údaje o vás zpracováváme, případně požadovat jejich opravu nebo odstranění, kontaktujte nás prostřednictvím e-mailu uvedeného na této stránce.",
			)}
		</p>
		<h2 class="mt-12 text-lg lg:text-[2rem]">{nbspify("Obecná ustanovení")}</h2>
		<p>
			{nbspify(
				"Vaše osobní údaje zpracováváme v souladu se zákonem č. 110/2019 Sb., o zpracování osobních údajů, a v souladu s nařízením GDPR. Máte právo obrátit se se svými dotazy nebo stížnostmi na Úřad pro ochranu osobních údajů.",
			)}
			(<a
				class="underline hover:text-gray-400"
				target="_blank"
				href="https://uoou.gov.cz/pravni-ramec/ochrana-osobnich-udaju">ÚOOÚ</a
			>)
		</p>
	</div>
</Layout>
